import { Injectable } from '@angular/core';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { keyStorage } from '../constants/storage';
import { getLocalStorage, setLocalStorage } from '../utils/storage';

@Injectable({
    providedIn: 'root',
})
export class HttpRequestService {
    constructor() {}

    private getConfig() {
        const config: AxiosRequestConfig<any> = {
            headers: {
                Authorization: `Bearer ${
                    getLocalStorage(keyStorage.accessToken) ?? ''
                }`,
            },
            timeout: 3.6e6,
        };

        return config;
    }

    async axiosGet(url: string, config?: AxiosRequestConfig<any>) {
        try {
            const result = await axios.get<any, AxiosResponse<any>>(
                url,
                config
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async axiosGetWithToken(url: string) {
        try {
            const result = await axios.get<any, AxiosResponse<any>>(
                url,
                this.getConfig()
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async axiosPost(url: string, data?: any) {
        try {
            const result = await axios.post<any, AxiosResponse<any>>(url, data);
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async axiosPostWithToken(url: string, data?: any, cancelToken?: any) {
        try {
            const result = await axios.post<any, AxiosResponse<any>>(
                url,
                data,
                {
                    ...this.getConfig(),
                    cancelToken,
                }
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async axiosPut(url: string, data?: any) {
        try {
            const result = await axios.put<any, AxiosResponse<any>>(url, data);
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async axiosPutWithToken(url: string, data?: any) {
        try {
            const result = await axios.put<any, AxiosResponse<any>>(
                url,
                data,
                this.getConfig()
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async axiosDelete(url: string) {
        try {
            const result = await axios.delete<any, AxiosResponse<any>>(url);
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async axiosDeleteWithToken(url: string) {
        try {
            const result = await axios.delete<any, AxiosResponse<any>>(
                url,
                this.getConfig()
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async getIP() {
        try {
            const result = await axios.get('https://api.ipify.org');
            setLocalStorage(keyStorage.address, result.data);
            return result.data;
        } catch (err) {
            return err;
        }
    }
}
